import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IConfigState } from './config';
import { DEBOUNCE_TIME_BARCODE, DEFAULT_TIMER_TO_FOCUS } from '@poste-click-connect/shared-ui';

const exampleStateSelector = createFeatureSelector<IConfigState>('config');

export const selectBasepath = createSelector(
  exampleStateSelector,
  (state: IConfigState) => state.basepath
);

export const selectIsMaintainance = createSelector(
  exampleStateSelector,
  (state: IConfigState) => state.isMaintainance
);

export const selectSurvey = createSelector(
  exampleStateSelector,
  (state: IConfigState) => state.surveyUrl
);

export const selectShowSurvey = createSelector(
  exampleStateSelector,
  (state: IConfigState) => state.abilitato
);

export const selectCaptchaLength = createSelector(
  exampleStateSelector,
  (state: IConfigState) => state.captchaLength
);

export const selectTentativeLogin = createSelector(
  exampleStateSelector,
  (state: IConfigState) => state.tentativeLogin
);

export const selectIsLottomatica = createSelector(
  exampleStateSelector,
  (state: IConfigState) => state.isLottomatica
);

export const selectRegexDHL = createSelector(
  exampleStateSelector,
  (state: IConfigState) => state.regexCodiceDhlInbound
);

export const selectApplicationVersion = createSelector(
  exampleStateSelector,
  (state: IConfigState) => state.applicationVersion || ''
);

export const selectSeparatorRegexDHL = createSelector(
  exampleStateSelector,
  (state: IConfigState) => state.regexCodiceDhlInboundCodeSeparator
);

export const selectNumberOfResultsPerPage = createSelector(
  exampleStateSelector,
  (state: IConfigState) => state.numberOfResultsPerPage
);

export const selectGiorniAnticipoFerie = createSelector(
  exampleStateSelector,
  (state: IConfigState) => state.giorniAnticipoFerie
);

export const selectDebounceTime = createSelector(
  exampleStateSelector,
  (state: IConfigState) => state.debounceTime || DEBOUNCE_TIME_BARCODE
);

export const selectHomepageLink = createSelector(
  exampleStateSelector,
  (state: IConfigState) => state.lottomaticaHomepage
);

export const selectIsNotificationPresent = createSelector(
  exampleStateSelector,
  (state: IConfigState) => ({
    isNotificationPresent: state.isNotificationPresent,
    messaggioHeader: state.messaggioHeader,
    nuovaComunicazione: state.nuovaComunicazione,
  })
);

export const selectBarcodeAmz = createSelector(
  exampleStateSelector,
  ({
    Barcode01ReverseAmzW,
    Barcode01ReverseAmzH1,
    Barcode01ReverseAmzH2,
    Barcode02ReverseAmzW,
    Barcode02ReverseAmzH1,
    Barcode02ReverseAmzH2,
    Barcode03ReverseAmzH1,
    Barcode01ReversePOUW,
    Barcode01ReversePOUH1,
    Barcode01ReversePOUH2,
    Barcode02ReversePOUH1,
    Barcode02ReversePOUH2,
  }: IConfigState) => ({
    Barcode01ReverseAmzW,
    Barcode01ReverseAmzH1,
    Barcode01ReverseAmzH2,
    Barcode02ReverseAmzW,
    Barcode02ReverseAmzH1,
    Barcode02ReverseAmzH2,
    Barcode03ReverseAmzH1,
    Barcode01ReversePOUW,
    Barcode01ReversePOUH1,
    Barcode01ReversePOUH2,
    Barcode02ReversePOUH1,
    Barcode02ReversePOUH2,
  })
);

export const selectExpiredObjectConfig = createSelector(
  exampleStateSelector,
  ({
    giornataLavorativa,
    oggettiScadutiOggi,
    oggettiScadutiPrimaDiOggi,
    frequenzaPopupOggettiScaduti,
  }: IConfigState) => ({
    giornataLavorativa,
    oggettiScadutiOggi,
    oggettiScadutiPrimaDiOggi,
    frequenzaPopupOggettiScaduti,
  })
);

export const selectTimerForLoginFocus = createSelector(
  exampleStateSelector,
  (state: IConfigState) => state.timerForLoginFocus || DEFAULT_TIMER_TO_FOCUS
);

export const selectIsRedirectEnable = createSelector(
  exampleStateSelector,
  (state: IConfigState) => state.isRedirectForFocusEnabled
);


